import { Injectable } from '@angular/core';

import { UIRouter } from '@uirouter/core';

import { ApiService }               from '../api/api.service';
import { MessagesService }          from '../messages/messages.service';
import { UnitTransactionLinkModel } from './typings/unit.transaction-link';

@Injectable({
  providedIn: 'root'
})
export class UnitTransactionService {

  constructor (
    private apiService     : ApiService,
    private messagesService: MessagesService,
    private router         : UIRouter
  ) {}

  // An acquisition row can point at a supplier invoice or a stock order; the back end says which.
  openLinkedRecord ( transactionId : string ) : Promise<void> {
    return this.apiService.get('/dealership_transaction_logs/link_details_for_log', transactionId)
    .then(( link : UnitTransactionLinkModel ) => {
      if (link.object === 'invoice') {
        this.router.stateService.go('app.dealership.sale', {
          customer_id: link.parent_id,
          id         : link.id,
          vehicle_id : link.vehicle_id
        });
      }
      else if (link.object === 'purchase_order') {
        this.router.stateService.go('app.purchase-order', {
          id       : link.id,
          vendor_id: link.parent_id
        });
      }
      else {
        this.router.stateService.go('app.vendor-invoice', {
          id        : link.id,
          vehicle_id: link.vehicle_id,
          vendor_id : link.parent_id
        });
      }
    })
    .catch(error => this.messagesService.error(error));
  }
}
